/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Teams_Add_Member_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to add member to the team. Please try again." |
*
* @param {Teams_Add_Member_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const teams_add_member_error = /** @type {((inputs?: Teams_Add_Member_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Teams_Add_Member_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Hinzufügen des Mitglieds zum Team. Bitte versuche es erneut.")
	return /** @type {LocalizedString} */ ("Failed to add member to the team. Please try again.")
});